import { useState } from 'react';
import { getStorageItem, putStorageItem } from 'utils/helpers';

const useLocalStorage = (key: string, initialValue = '') => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      return getStorageItem(key, initialValue);
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });

  const setValue = (value: (storedValue: string) => string) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      putStorageItem(key, valueToStore);
    } catch (error) {
      console.log(error);
    }
  };

  return [storedValue, setValue];
};

export default useLocalStorage;
